export default "__VITE_ASSET__C0V4xkRu__"